import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { dateFormat, timeFormat } from "../../../../../../helpers/date/date";
const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: "row",
    marginTop: 1,
    display: "flex",
    alignSelf: "center",
  },
  document: {
    color: "#4B44BE",
    fontSize: 18,
    textTransform: "uppercase",
    fontFamily: "Helvetica-Bold",
    marginRight: 60,
  },
  numb: {
    color: "#4B44BE",
    fontSize: 12,
    textTransform: "uppercase",
    fontFamily: "Helvetica-Bold",
    marginLeft: 10,
  },
});

const DocumentName = ({ title, from, to }) => (
  <View style={styles.titleContainer}>
    <Text style={styles.document}>{title}</Text>
    <Text style={styles.numb}>
      {dateFormat(new Date(Date.now()))} {timeFormat(new Date(Date.now()))}
    </Text>
  </View>
);

export default DocumentName;
